<template>
  <b-modal
    id="createform"
    centered
    hide-footer
    hide-header
    size="md"
    :visible="isCreateForm"
    no-close-on-backdrop
    @hidden="closeModal()"
  >
    <div class="d-flex align-items-center justify-content-between">
      <div class="teams-modal-head">
        {{ createForm.header }}
      </div>

      <div @click="closeModal()">
        <img
          :style="showButtonLoader ? 'opacity:50%' : ''"
          src="../../assets/New-imgs/teams-icons/teams-close-icon.svg"
          alt=""
          :class="!showButtonLoader ? 'pointer rotate-on-hover' : ''"
        />
      </div>
    </div>
    <hr />
    <div class="mt-3">
      <div class="topDiv">
        <label class="teams-label-font"
          >{{ createForm.subHeader }}<span class="asterik">*</span></label
        >

        <b-form-input
          class="mt-2 teams-inputField"
          v-model.trim="createForm.name"
          :placeholder="createForm.placeholder"
          type="text"
          v-on:keyup.enter="goToCreateForm"
          autofocus
          :class="{
            'teams-inputField-error':
              $v.createForm.name.$error ||
              !$v.createForm.name.maxLength ||
              !$v.createForm.name.alpha,
          }"
        >
        </b-form-input>
        <div
          class="newInt-required-validation-font mt-1"
          v-if="$v.createForm.name.$dirty && !$v.createForm.name.required"
        >
          Required
        </div>
        <div
          class="newInt-required-validation-font mt-1"
          v-if="!$v.createForm.name.maxLength && $v.createForm.name.required"
        >
          Should not exceed 128 characters
        </div>
        <div
          class="newInt-required-validation-font mt-1"
          v-if="!$v.createForm.name.alpha && $v.createForm.name.required"
        >
          Please Enter a Valid Name
        </div>
      </div>
      <div class="topDiv mt-3">
        <label class="teams-label-font"
          >{{ createForm.count }}<span class="asterik">*</span></label
        >

        <b-form-input
          class="mt-2 teams-inputField"
          v-model="createForm.countOf"
          :placeholder="createForm.placeholder"
          type="number"
          v-on:keyup.enter="goToCreateForm"
          :max="$route.query.status == 'interviewProcess' ? 10 : ''"
          :class="{
            'teams-inputField-error':
              $v.createForm.countOf.$error ||
              !$v.createForm.countOf.maxValue ||
              !$v.createForm.countOf.minValue,
          }"
          @keydown="preventInvalidInput"
          :min="1"
        >
        </b-form-input>
        <div
          class="newInt-required-validation-font mt-1"
          v-if="$v.createForm.countOf.$dirty && !$v.createForm.countOf.required"
        >
          Required
        </div>
        <div
          class="newInt-required-validation-font mt-1"
          v-if="!$v.createForm.countOf.maxValue"
        >
          Should not exceed
          {{
            $route.query.status == "interviewProcess"
              ? "10 rounds"
              : "100 skills"
          }}
        </div>
        <div
          class="newInt-required-validation-font mt-1"
          v-if="!$v.createForm.countOf.minValue"
        >
          Should not be less than 1
          {{ $route.query.status == "interviewProcess" ? "round" : "skill" }}
        </div>
      </div>
    </div>

    <hr class="mt-4" />

    <div class="d-flex align-items-center justify-content-end mt-4">
      <div class="cancelpan-btn mr-3">
        <b-button
          class="addbtn h-32 w-87"
          :disabled="showButtonLoader"
          @click="closeModal()"
          >Cancel</b-button
        >
      </div>
      <div class="addpanellog position-relative">
        <b-button
          :class="showButtonLoader ? 'givefeed-loader-class' : 'pointer'"
          class="addbtn h-32 w-87"
          @click="goToCreateForm()"
          ><span v-if="!showButtonLoader"> Create </span>
        </b-button>
        <div v-if="showButtonLoader" class="loader-pos">
          <Loader />
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import {
  required,
  maxLength,
  helpers,
  maxValue,
  minValue,
} from "vuelidate/lib/validators";
import Loader from "../../components/fixedcomponents/Loader.vue";

export default {
  name: "CreateForm",
  components: {
    Loader,
  },
  validations() {
    return {
      createForm: {
        name: {
          required,
          maxLength: maxLength(128),
          alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
        },
        countOf: {
          required,
          maxValue:
            this.$route.query.status === "interviewProcess"
              ? maxValue(10)
              : maxValue(100),
          minValue: minValue(1),
        },
      },
    };
  },

  props: {
    isCreateForm: Boolean,
    createForm: Object,
    showButtonLoader: Boolean,
  },
  methods: {
    preventInvalidInput(e) {
      const invalidChars = ["e", "E", "+", "-", "."];
      if (invalidChars.includes(e.key)) {
        e.preventDefault();
      }
    },
    closeModal() {
      this.$emit("closeModal");
    },
    goToCreateForm() {
      this.$v.$touch();

      if (this.$v.$invalid) return;
      this.$emit("handle-create-form");
    },
  },
};
</script>
<style>
.loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: -2px;
}
.givefeed-loader-class {
  opacity: 0.5;
  height: 32px;
  width: 87px;
}
</style>
